import { CurrentUser_paymentMethod } from '../../core-types';
import { Box, Text, Flex, Image } from '../../components';
import { FormattedMessage } from 'react-intl';

export const PaymentCard = ({
  paymentMethod
}: {
  paymentMethod: CurrentUser_paymentMethod;
}) => {
  return (
    <Flex
      p={4}
      borderWidth="1px"
      borderStyle="solid"
      borderColor="primary"
      borderRadius="md"
      alignItems="center"
      textAlign="center"
    >
      {paymentMethod.__typename === 'Card' && (
        <>
          <Box mr={4}>
            <Image
              src={`/static/payment-icons/${paymentMethod.brand}.svg`}
              width={100}
              alt={paymentMethod.displayBrand}
            />
          </Box>
          <Box mr={4}>
            <Text typoStyle="xxs" mb={1}>
              <FormattedMessage
                id="paymentCard.endingWith"
                defaultMessage="Ending with"
              />
            </Text>
            <Text typoStyle="sm">{paymentMethod.last4}</Text>
          </Box>
          <Box>
            <Text typoStyle="xxs" mb={1}>
              <FormattedMessage id="expires" defaultMessage="Expires" />
            </Text>
            <Text
              typoStyle="sm"
              color={paymentMethod.expired ? 'state.error' : undefined}
            >
              {paymentMethod.expiresAt}
            </Text>
          </Box>
        </>
      )}
    </Flex>
  );
};
